/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { ColorBlock } from "src/classes/block/block-types";
import { StyledColorBlockContent } from "src/components/Block/BlockTypes/ColorBlock/styles";

interface Props {
  block: ColorBlock;
}
export function SColorBlock({ block }: Props) {
  return <StyledColorBlockContent color={block.snapshot.hex} />;
}
